import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useI18n } from "@/i18n";
import { useApp } from "@/context/AppContext";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { BookOpen, RotateCcw } from "lucide-react";
import { GuidaContenuto } from "@/components/Benvenuto";
import { SpiegaGiri } from "@/components/SpiegaGiri";
import { benvenuto } from "@/data/benvenuto";

export default function Guida() {
  const { lang } = useI18n();
  const { showcase } = useApp();
  const nav = useNavigate();
  const b = benvenuto(lang);
  const [passo, setPasso] = useState(0);

  return (
    <div className="fade-up max-w-2xl space-y-5" data-testid="guida-page">
      <div>
        <p className="text-[10px] font-bold uppercase tracking-[0.24em] text-slate-500">Reprehendo</p>
        <h1 className="mt-1 text-3xl font-bold tracking-tight sm:text-4xl">{b.ui.guideTitle}</h1>
        <p className="mt-1 text-sm text-slate-500">{b.ui.guideSub}</p>
      </div>

      <Card className="p-5">
        <GuidaContenuto passo={passo} setPasso={setPasso} />
      </Card>

      <Card className="flex flex-wrap items-center justify-between gap-3 p-5" data-testid="guida-giri-card">
        <div className="min-w-0">
          <h2 className="text-base font-bold md:text-lg">I giri: la domanda che fanno tutti</h2>
          <p className="mt-1 text-sm text-slate-500">
            «Cosa sono i giri e come funzionano?» In trenta secondi, con un esempio di servizio vero.
          </p>
        </div>
        <SpiegaGiri testo="Aprilo qui" className="text-sm" />
      </Card>

      <div className="flex flex-wrap gap-2">
        {!showcase && (
          <Button variant="outline" onClick={() => nav("/manuale")} data-testid="guida-manuale-btn">
            <BookOpen className="mr-1.5 h-4 w-4" /> {b.ui.manual}
          </Button>
        )}
        <Button
          variant="outline"
          data-testid="guida-reset-btn"
          onClick={() => {
            Object.keys(localStorage)
              .filter((k) => k.startsWith("rh_welcome_"))
              .forEach((k) => localStorage.removeItem(k));
            setPasso(0);
            window.location.reload();
          }}
        >
          <RotateCcw className="mr-1.5 h-4 w-4" /> {b.ui.again}
        </Button>
      </div>
    </div>
  );
}
